import React from 'react';
import { Box, Typography } from '@mui/material';
import archive1 from '../assets/archives/archive1.JPG';

export default function Archives() {
    const images = [
        {
            src: archive1,
            caption:
                'Construction of mill houses on the south end, west side of Barlow St. G. W. Morgan on porch, Boyd Morgan sitting right of chimney, Lloyd Morgan standing second on it of chimney (top), Cap Morgan standing third on it of chimney (top). Picture made 1914.',
        },
    ];

    return (
        <Box sx={{ maxWidth: 1000, mx: 'auto', py: { xs: 4, md: 6 }, px: { xs: 2, md: 2 } }}>
            <Typography
                variant="h4"
                align="center"
                gutterBottom
                sx={{
                    fontWeight: 700,
                    fontSize: { xs: '1.6rem', sm: '1.8rem', md: undefined },
                    lineHeight: { xs: 1.25, sm: 1.25, md: undefined },
                }}
            >
                Coming Soon!
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: 'flex-start',
                    gap: { xs: 3, sm: 4, md: 4 },
                    mt: { xs: 1, md: 2 },
                }}
            >
                <Box sx={{ flex: 1 }}>
                    {images.map((item, idx) => (
                        <Box key={idx} sx={{ mb: idx < images.length - 1 ? 3 : 0 }}>
                            <Box
                                component="img"
                                src={item.src}
                                alt={`Archive ${idx + 1}`}
                                loading="lazy"
                                decoding="async"
                                sx={{
                                    width: '100%',
                                    display: 'block',
                                    borderRadius: { xs: 1.5, md: 1 },
                                    objectFit: 'cover',
                                    boxShadow: { xs: 1, md: 0 },
                                }}
                            />
                            <Typography
                                variant="caption"
                                display="block"
                                sx={{
                                    mt: 1,
                                    color: 'text.secondary',
                                    fontSize: { xs: '0.85rem', sm: '0.8rem', md: '0.75rem' },
                                    lineHeight: 1.5,
                                }}
                            >
                                {item.caption}
                            </Typography>
                        </Box>
                    ))}
                </Box>

                <Box sx={{ flex: 1, maxWidth: { md: '65ch' } }}>
                    <Typography paragraph sx={{ fontSize: { xs: '1rem', sm: '1.025rem' }, lineHeight: { xs: 1.7, md: 1.75 } }}>
                        At the Piedmont Historical Society, we safeguard an enormous treasure trove of artifacts, photographs,
                        and memorabilia that chronicle the rich history of our town and its people.
                    </Typography>
                    <Typography paragraph sx={{ fontSize: { xs: '1rem', sm: '1.025rem' }, lineHeight: { xs: 1.7, md: 1.75 } }}>
                        Many of these items have been tucked away in our archives for decades, never before made available to the
                        public. Each photograph and object tells a unique story of 19th and 20th‑century life.
                    </Typography>
                    <Typography paragraph sx={{ fontSize: { xs: '1rem', sm: '1.025rem' }, lineHeight: { xs: 1.7, md: 1.75 } }}>
                        We are currently undertaking a comprehensive project to scan and digitize each photograph, document, and
                        object. This will allow the history of Piedmont and our surrounding area to be preserved for generations
                        to come.
                    </Typography>
                    <Typography paragraph sx={{ fontSize: { xs: '1rem', sm: '1.025rem' }, lineHeight: { xs: 1.7, md: 1.75 } }}>
                        Once fully digitized, the entire collection will be posted here on our site for historians, students, and
                        community members to explore and learn more about the history of Piedmont and the surrounding region. Stay
                        tuned. Our archive will be open to everyone very soon!
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}
